import env from '@/env'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueRouter from 'vue-router'
import store from './store/store'
import './registerServiceWorker'
import { MessageBox } from 'element-ui'
import i18n from './i18n'
import PortalVue from 'portal-vue'
import dashboardPlugin from './plugins/dashboardPlugin'
import echartsPlugin from './plugins/echartsPlugin'
import storageLoggerPlugin from './plugins/storageLoggerPlugin'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/icon-vc.css'
import VueDraggableResizable from 'vue-draggable-resizable'


Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(PortalVue)
Vue.use(dashboardPlugin)
Vue.use(echartsPlugin)
Vue.use(storageLoggerPlugin)

Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$isDev = env.VITE_APP_API_URL.includes('dev')

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
})
    .$mount('#app')

// initRealTimeSdk()
//     .then(() => {
//         console.log('Real time SDK Initialized')
//     })
// //
